import { render } from "./widget.vue?vue&type=template&id=638d016e"
import script from "./widget.vue?vue&type=script&lang=js"
export * from "./widget.vue?vue&type=script&lang=js"

import "./widget.vue?vue&type=style&index=0&id=638d016e&lang=css"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__